@if (icon) {
<div class="menu-item-icon-container mr-2">
  <fa-icon class="menu-item-icon" [icon]="icon" size="xs"></fa-icon>
</div>
}
<ng-content></ng-content>
@if (isActive) {
<fa-icon [icon]="['fas', 'check']" class="active-icon"></fa-icon>
}
